import { DestroyRef, Directive, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EnhancedAbsenceModel } from '@reducers/orm/absence/absence.model';
import { getEnhancedAbsenceById } from '@reducers/orm/absence/absence.service';

import { FeatureService } from '../../../startup/feature.service';
import { AbsenceRequestAction, AbsenceRequestOriginator } from './absence-request.models';

@Directive({
  standalone: true,
  selector: '[appAbsenceRequest]',
})
export class AbsenceRequestDirective implements OnInit {
  @Input()
  public set appAbsenceRequest(context: {
    absenceId: string;
    isOwnAbsence?: boolean;
    action?: AbsenceRequestAction;
    originator: AbsenceRequestOriginator;
  }) {
    this.absenceId = context.absenceId;
    this.originator = context.originator;
    if (context.action) {
      this.action = context.action;
    }
  }

  @HostBinding('class')
  private readonly class = 'cursor-pointer';

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent) {
    event.stopPropagation();
    switch (this.action) {
      case 'edit':
        this.openEditModal();
        break;
      default:
        this.openRequestModal();
    }
  }

  private absenceId: string;
  private absence: EnhancedAbsenceModel;
  private action: AbsenceRequestAction = 'view';
  private originator: AbsenceRequestOriginator;

  public constructor(
    private store: Store,
    private feature: FeatureService,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {}

  public ngOnInit(): void {
    this.setAbsence();
  }

  private openRequestModal() {
    this.router.navigate([
      '',
      { outlets: { modal: ['absence-request', this.absenceId, { originator: this.originator }] } },
    ]);
  }

  private openEditModal() {
    this.router.navigate([
      '',
      { outlets: { modal: ['absence-edit', this.absenceId, { originator: this.originator }] } },
    ]);
  }

  private setAbsence() {
    void this.store
      .select(getEnhancedAbsenceById(this.absenceId))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((absence: EnhancedAbsenceModel) => (this.absence = absence));
  }
}
